<template>
    <div class="mt-2" v-if="account">
        <div v-if="geoInfo">
            <v-layout row justify-space-between>
                <div class="ml-2 pl-1 mt-2">
                    <v-layout
                        row
                        class="mb-1 mx-3 pt-1"
                        v-bind="{ 'pt-3': !geoInfo.busAddress2 }"
                    >
                        <div class="font-weight-medium mr-2">
                            Geo OK:
                        </div>
                        <div>
                            {{ geoInfo.geoOK ? "Yes" : "No" }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-1 mx-3 pt-1">
                        <div class="font-weight-medium mr-2">
                            Bus Address 1:
                        </div>
                        <div>
                            {{ geoInfo.busAddress1 }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        class="mb-0 mx-3 pt-0"
                        v-if="geoInfo.busAddress2"
                    >
                        <div class="font-weight-medium mr-2">
                            Bus Address 2:
                        </div>
                        <div>
                            {{ geoInfo.busAddress2 }}
                        </div>
                    </v-layout>
                </div>
                <div class="mr-3">
                    <v-layout
                        row
                        class="my-2 mr-2"
                        v-for="phone in phoneNumbers"
                    >
                        <div class="font-weight-medium mr-2">
                            {{ getPhoneType(phone.phoneType) }}:
                        </div>
                        <div>
                            {{ phone.phoneNum }}
                        </div>
                    </v-layout>
                </div>
            </v-layout>
        </div>

        <v-progress-linear
            class="px-3"
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>

        <div v-if="!loading">
            <div class="title mx-3 mb-0 mt-3" v-if="!geoDetails.length">
                No Student Stops
            </div>

            <div v-if="geoDetails.length">
                <v-layout row class="mx-3 mt-2">
                    <v-divider class="mt-3"></v-divider>
                    <div class="title mx-3 mb-0">Student Stops</div>
                    <v-divider class="mt-3"></v-divider>
                </v-layout>
                <v-layout row class="mx-3">
                    <v-spacer></v-spacer>
                    <div class="caption text-info">
                        Last Updated: {{ lastUpdated }}
                    </div>
                </v-layout>

                <div class="mx-3 mt-2">
                    <div v-for="(student, index) in geoDetails">
                        <div
                            class="title text-success"
                            style="margin-bottom: 0px !important;"
                        >
                            {{
                                student.firstName +
                                    " (" +
                                    student.building +
                                    "-" +
                                    student.branch +
                                    "-" +
                                    student.class +
                                    "-" +
                                    student.section +
                                    ")"
                            }}
                        </div>
                        <v-layout row class="caption ml-0 mb-2">
                            <div class="font-weight-medium mr-1">
                                Enabled:
                            </div>
                            <div
                                v-bind:class="{
                                    'text-success': student.isRegistered,
                                    'text-danger': !student.isRegistered,
                                }"
                            >
                                {{ student.isRegistered ? "Yes" : "No" }}
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            v-for="geo in student.list"
                            class="mx-0 mb-1"
                        >
                            <div class="font-weight-medium mr-1">
                                Schedule:
                            </div>
                            <div class="mr-2 width-250">{{ geo.schedule }}</div>
                            <div class="font-weight-medium mr-1">Address:</div>
                            <div class="mr-2 width-150">
                                {{ geo.stopAddress }}
                            </div>
                            <div class="font-weight-medium mr-1">Bus:</div>
                            <div class="mr-2 width-100">{{ geo.bus }}</div>
                            <div class="font-weight-medium mr-1">Stop:</div>
                            <div class="width-100">{{ geo.stopNumber }}</div>
                        </v-layout>
                        <v-divider
                            class="pb-2 mt-2"
                            v-if="index + 1 < geoDetails.length"
                            :key="index"
                        >
                        </v-divider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    formatPhoneNumber,
    except,
    toTitleCase,
    groupBy,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        account: Object,
        geoInfo: Object,
    },
    data() {
        return {
            geoDetails: [],
            phoneNumbers: [],
            lastUpdated: "",
            loading: true,
        };
    },
    async created() {
        this.load();
    },
    computed: {},
    methods: {
        async load() {
            try {
                const response = await this.$http.get(
                    "api/studentStop/getForFamily?familyID=" +
                        this.account.accountID,
                );

                this.loading = false;

                if (!response.studentStops.length) return;

                this.lastUpdated = moment(
                    response.studentStops[0].updatedOn,
                ).format("MM/DD/YYYY h:mm:ss A");

                this.phoneNumbers = response.geoPhones;

                const group = groupBy(response.studentStops, "studentID");

                this.geoDetails = Object.keys(group).map((key) => {
                    const student = response.geoStudents.find(
                        (s) => s.studentID.trim() == key,
                    );

                    return {
                        studentID: key,
                        firstName: group[key][0].firstName,
                        class: group[key][0].class,
                        branch: student.branch,
                        section: student.section,
                        building: student.building,
                        list: group[key],
                        isRegistered: student.isRegistered,
                    };
                });

                this.$forceUpdate();
            } catch (e) {
                this.loading = false;
            }
        },
        getPhoneType(phoneType) {
            switch (phoneType) {
                case "PHON":
                    return "Home Phone";
                case "CEL":
                    return "Cellphone";
                case "MCEL":
                    return "Mother Cellphone";
            }
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
</style>
